import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { WALLET_UPDATE_PAYMENTS_INFO_COMPLETED } from 'wallet-manager';

import { eventBus } from '@atc/cai-event-bus';

export default function useWalletManager({ currentPaymentsInfoRef, paymentsDuck }) {
    const dispatch = useDispatch();

    const updatePaymentsInfoWithWalletManager = ({ updated, updatedPaymentsInfo }) => {
        if (updated) {
            if (currentPaymentsInfoRef?.current) {
                currentPaymentsInfoRef.current = {
                    ...currentPaymentsInfoRef.current,
                    ...updatedPaymentsInfo,
                };
            }
            dispatch({
                type: paymentsDuck.types.SET_PAYMENT_INFO,
                payload: { ...updatedPaymentsInfo },
            });
        }
    };

    useEffect(() => {
        eventBus.on(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, updatePaymentsInfoWithWalletManager);
        return () => {
            eventBus.off(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, updatePaymentsInfoWithWalletManager);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
